import React from 'react';
import Button from '@material-ui/core/Button';
import history from '../../history';

import { MacroContainer, EntryContainer, LogoContainer, TitleContainer} from './entry-page.styles';


const EntryPage = () => {

    return (
        <MacroContainer>
            <EntryContainer>
                <LogoContainer>
                        <img id="logo" alt="logo"  src={require("../../assets/mrsLogo.png")} height="auto" width="100%" />
                </LogoContainer>

                <TitleContainer>I want to reserve a Mass!</TitleContainer>

                <Button color="primary" variant="contained" style={{fontSize: "18px", marginTop: "20px", marginBottom: "20px", width: "300px", textAlign: "left"}} 
                    onClick={() => history.push('/signin')}>Sign-in</Button>
                <Button color="secondary" variant="contained" style={{fontSize: "18px", marginTop: "20px", marginBottom: "20px", width: "300px", textAlign: "left"}} 
                onClick={() => history.push('/register')}>Create an Account</Button>
            </EntryContainer>
        </MacroContainer>
    );
};

export default EntryPage;